/**
 * The answer key of a numbers game is the author's expression. Kept apart from the form so the
 * eagerly loaded module file never pulls it into the player bundle.
 */
import type { CountdownDefinition, CountdownSolution } from "./types";

export function emptySolution(_definition: CountdownDefinition): CountdownSolution {
  return { expression: "" };
}

/** Reads whatever is stored, however wrong, and keeps the string it can use. */
export function expressionOf(value: unknown): string {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return "";
  const { expression } = value as { expression?: unknown };
  return typeof expression === "string" ? expression : "";
}
